import type { File as FileEntity } from "@zhihaoscm/entity";
import { fileService } from "@/api/services/fileService";
import type { UploadRawFile, UploadRequestOptions, UploadUserFile } from "zhihao-ui-react";

/** 上传组件允许调用方复用旧版的业务上传接口。 */
export type UploadApi = (params: FormData) => Promise<FileEntity & { fileUrl?: string }>;

/** 将浏览器文件转换成旧版上传接口需要的 multipart 请求。 */
export async function uploadFile(
    options: UploadRequestOptions,
    api?: UploadApi
): Promise<FileEntity & { fileUrl?: string }> {
    const formData = new FormData();
    formData.append("file", options.file);
    // 保留 fileService 方法的实例上下文，否则默认上传会在发请求前因 this.service 缺失而失败。
    return (api ? api(formData) : fileService.uploadFile(formData)) as Promise<FileEntity & { fileUrl?: string }>;
}

/** 保持 Vue 组件原有的类型、大小校验口径。 */
export function validateUploadFile(file: UploadRawFile, fileTypes: string[], sizeInMb: number, messagePrefix = "文件") {
    const suffix = file.name.includes(".") ? `.${file.name.split(".").pop()?.toLowerCase()}` : "";
    const typeMatched = fileTypes.some(type => {
        const normalized = type.toLowerCase();
        return (
            normalized === file.type.toLowerCase() ||
            normalized === suffix ||
            (normalized.endsWith("/*") && file.type.startsWith(normalized.slice(0, -1)))
        );
    });
    const sizeMatched = file.size / 1024 / 1024 < sizeInMb;
    if (!typeMatched)
        window.dispatchEvent(new CustomEvent("zh-upload-error", { detail: `${messagePrefix}格式不符合要求` }));
    if (!sizeMatched)
        window.dispatchEvent(
            new CustomEvent("zh-upload-error", { detail: `${messagePrefix}大小不能超过 ${sizeInMb}M` })
        );
    return typeMatched && sizeMatched;
}

/** 兼容文件详情回显所需的 Upload 文件结构。 */
export function toUploadUserFile(file: FileEntity | undefined): UploadUserFile[] {
    if (!file) return [];
    return [{ name: file.name, url: file.path, response: file }];
}
